export const fmt = {
  currency: n => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(n || 0),
  currencyFull: n => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n || 0),
  date: d => d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—',
  shortDate: d => d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '—',
  number: n => new Intl.NumberFormat('en-US').format(n || 0),
  percent: n => `${Math.round(n || 0)}%`,
};

export const initials = name => name ? name.split(' ').filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase() : '?';

export const avatarColor = name => {
  const colors = ['#2563eb','#7c3aed','#059669','#d97706','#e11d48','#0284c7'];
  let h = 0;
  for (let i = 0; i < (name||'').length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return colors[Math.abs(h) % colors.length];
};

export const daysUntil = d => {
  if (!d) return null;
  return Math.ceil((new Date(d) - new Date()) / 86400000);
};

export const daysAgo = d => {
  if (!d) return null;
  return Math.floor((new Date() - new Date(d)) / 86400000);
};

export const timeAgo = iso => {
  if (!iso) return '';
  const m = Math.floor((Date.now() - new Date(iso)) / 60000);
  if (m < 1) return 'Just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};

export const statusLabel = s => ({
  occupied:'Occupied', vacant:'Vacant', maintenance:'Maintenance', offline:'Offline',
  active:'Active', expired:'Expired', terminated:'Terminated', pending:'Pending',
  paid:'Paid', overdue:'Overdue', refunded:'Refunded', cancelled:'Cancelled',
  open:'Open', in_progress:'In Progress', scheduled:'Scheduled', completed:'Completed',
  admin:'Admin', manager:'Manager', accountant:'Accountant',
  rent:'Rent', deposit:'Deposit', late_fee:'Late Fee', other:'Other',
  high:'High', medium:'Medium', low:'Low',
  inactive:'Inactive', suspended:'Suspended',
}[s] || s);

export const statusClass = s => ({
  occupied:'badge-active', active:'badge-active', paid:'badge-active', completed:'badge-active',
  vacant:'badge-vacant',
  maintenance:'badge-pending', pending:'badge-pending', open:'badge-pending', in_progress:'badge-info',
  overdue:'badge-overdue', expired:'badge-overdue', terminated:'badge-overdue',
  scheduled:'badge-brand',
  inactive:'badge-neutral', offline:'badge-neutral', cancelled:'badge-neutral',
}[s] || 'badge-neutral');

export const priorityClass = p => ({ high:'badge-overdue', medium:'badge-pending', low:'badge-neutral' }[p] || 'badge-neutral');

export const errMsg = err => err?.response?.data?.message || err?.message || 'An error occurred';
